module.exports = __webpack_public_path__ + "media/images/sos_villages_d_enfants-b63fcbe61e9c539a772e5a053316969c.png";